var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.overflown ? _c('div', {
    ref: "bar",
    staticClass: "cui-scrollbar-horizontal",
    style: _vm.barStyle,
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleScrollbarClick($event);
      }
    }
  }, [_c('div', {
    ref: "bobber",
    staticClass: "cui-scrollbar-horizontal__bobber bobber",
    style: _vm.bobberStyle,
    on: {
      "mousedown": function mousedown($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleBobberMousedown($event);
      },
      "touchstart": function touchstart($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleBobberTouchstart($event);
      }
    }
  })]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }